import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import { NavLink } from "react-router-dom";
import { spacing } from "@material-ui/system";

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 64px - 48px - 106px - 48px - 64px);
  position: relative;
`;

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Resources = () => {
  return (
    <>
      <Helmet title="Resources" />
      <Typography variant="h3" gutterBottom display="inline">
        Resources
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          Dashboard
        </Link>
        <Typography>Resources</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Container>
        <iframe
          src="https://docs.google.com/presentation/d/e/2PACX-1vTFYCa8eKgJMctC5_PWmaH1t7_Sc98GvzqErnKXfzC3uzNBQDsUH9TT8CKrGBFg-P0WzW_Dmq1c8rWM/embed?start=false&loop=false&delayms=3000"
          width="100%"
          height="100%"
          frameBorder="0"
          title="Resources"
        />
      </Container>
    </>
  );
};

export default Resources;
